import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ExamsService } from './exams.service';
import { LoginService } from './login.service';
import { PatientsService } from './patients.service';
import { Patient } from './patients/patient';

@Injectable({
  providedIn: 'root'
})
export class GastroFormsService implements OnDestroy{
  typeForm;
  Form;
  table;
  debounce=500;
  public loaded=false;
  pat;
  PID;
  form;
  isClosed = false
  // CreationTime;
  awlIndex;
  FormIndex;
  loadct:number;
  code: string;
  public signers;
  fetchImages: boolean;
  public env;
  public showPercentiles = true;
  recoveryMeas=[]
  totalRecoveryScore
  signs=[]
  htmlHeader


  public formLoaded$: Subject<void> = new Subject<void>();
  public htmlHeaderLoad$: Subject<void> = new Subject<void>();
  public paitentLoaded$: Subject<string> = new Subject<string>();
  CreationTime =  new Date()
  sub = new Subscription();
  listType=["habits", "preparetion", "diseases", "surgeries", "medications", "status","recovery"]
  list =[
    {name:"Smokes", displayName:"מעשן/ת", type:"habits"},
    {name:"Alcohol", displayName:"אלכוהול", type:"habits"},
    {name:"Drugs", displayName:"סמים", type:"habits"},
    {name:"Sleep", displayName:"כדורי שינה", type:"habits"},
    {name:"Allergies", displayName:"רגישות לחומרים", type:"habits"},
    {name:"DrugsAllergies", displayName:"רגישות לתרופות", type:"habits"},
    {name:"Nursing", displayName:"סיעודי", type:"preparetion"},
    {name:"OSA", displayName:"דום נשימה בשינה", type:"preparetion"},
    {name:"DAC", displayName:"תרופות נוגדות קרישה", type:"preparetion"},
    {name:"Dentures", displayName:"שיניים תותבות", type:"preparetion"},
    {name:"Escorted", displayName:"האם ישנו מלווה", type:"preparetion"},
    {name:"Guardian", displayName:"אפוטרופוס", type:"preparetion"},
    {name:"Hypertension", displayName:"יתר לחץ דם", type:"diseases"},
    {name:"RespiratoryDiseases", displayName:"מחלות ריאה (בעיקר אסטמה)", type:"diseases"},
    {name:"Arrhythmias", displayName:"הפרעות קצב לב", type:"diseases"},
    {name:"Diabetes", displayName:"סכרת/מחלות אנדוקרניות", type:"diseases"},
    {name:"Hepatitis", displayName:"הפטיטיס", type:"diseases"},
    {name:"Cancer", displayName:"סרטן", type:"diseases"},
    {name:"Radiation", displayName:"הקרנות/כימותרפיה", type:"diseases"},
    {name:"Cramps", displayName:"התכווצויות", type:"diseases"},
    {name:"Psychiatric", displayName:"מחלות פסיכיאטריות", type:"diseases"},
    {name:"Nervous", displayName:"מחלות עצבים", type:"diseases"},
    {name:"Surgeries", displayName:"ניתוחים", type:"surgeries"},
    {name:"PreMedication", displayName:"תרופות קבועות", type:"medications"},
    {name:"Medication", displayName:"האם קיבל תרופות היום", type:"status"},
    {name:"BloodThinners", displayName:"תרופות לדילול דם", type:"status"},
    {name:"Fast", displayName:"האם המטופל בצום", type:"status"},
    {name:"mobility", displayName:"תנועתיות  ", type:"recovery",value0:'אי יכולת להזיז עצמאית או על פי פקודה של הגפיים',value1:"יכולת עצמאית או על פי פקודה להזיז 2 גפיים",value2:"יכולת עצמאית או על פי פקודה להזיז 4 גפיים"},
    {name:"breathing", displayName:"נשימה ", type:"recovery",value0:'אפנאה',value1:"דיספנאה, נשימה שטוחה או מוגבלת",value2:"יכולת נשימה עמוקה ושיעול חופשי"},
    {name:"Hemodynamics", displayName:"המודינמיקה  ", type:"recovery",value0:' ל.ד גבוה מ 50 ',value1:"ל.ד בטווח 20-50",value2:"ל.ד עד 20"},
    {name:"recognition", displayName:"מצב הכרתי ", type:"recovery",value0:'אינו מגיב',value1:"ניתן להעיר בריאה",value2:"הכרה מלאה"},
    {name:"skinTone", displayName:"גוון עור  ", type:"recovery",value0:'ציאנוטי (כחלון)',value1:"חיוור",value2:"תקין"}

  ]
  constructor(public es:ExamsService, private fb:UntypedFormBuilder, private http:HttpClient, public patServ:PatientsService, private ls:LoginService) {
    
    this.sub = this.paitentLoaded$.subscribe((data) => {
      if(data['AWLID'])
        this.awlIndex = data['AWLID'];
      else{
        this.awlIndex = data;
      }
      if(this.awlIndex)
        this.loadForm(false,null);
    })
    if(es.isClosed){
      this.Form.disable({emitEvent:false})
    }
  }

  resetAdmissionForm(){
    this.Form = this.fb.group({
      AutoIndex: [''],
      UID:[''],
      PID:[''],
      GID:[''],
      AWLID:[''],
      CreationTime:[''],
      ID: [''],
      InstanceNumber: [''],
      Locked: [''],
      LockedBy: [''],
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      PatientIdentification:[''],
      Temp:[''],
      Pulse:[''],
      bpSystolic:[''],
      bpDyastolic:[''],
      CheckTime:[''],
      Smokes:[''],
      SmokesNote:[''],
      Alcohol:[''],
      AlcoholNote:[''],
      Drugs:[''],
      DrugsNote:[''],
      Sleep:[''],
      SleepNote:[''],
      Allergies:[''],
      AllergiesNote:[''],
      DrugsAllergies:[''],
      DrugsAllergiesNote:[''],
      Nursing:[''],
      NursingNote:[''],
      OSA:[''], //Obstructive Sleep Apnea
      OSANote:[''],
      DAC:[''],// Drugs Anti-coagulants 
      DACNote:[''],
      Dentures:[''],
      DenturesNote:[''],
      Escorted:[''],
      EscortedNote:[''],
      Guardian:[''],
      GuardianNote:[''],
      Hypertension:[''],
      HypertensionNote:[''],
      RespiratoryDiseases:[''],
      RespiratoryDiseasesNote:[''],
      Arrhythmias:[''],
      ArrhythmiasNote:[''],
      Diabetes:[''],
      DiabetesNote:[''],
      Hepatitis:[''],
      HepatitisNote:[''],
      Cancer:[''],
      CancerNote:[''],
      Radiation:[''],
      RadiationNote:[''],
      Cramps:[''],
      CrampsNote:[''],
      Psychiatric:[''],
      PsychiatricNote:[''],
      Nervous:[''],
      NervousNote:[''],
      Surgeries:[''],
      SurgeriesNote:[''],
      PreMedication:[''],
      PreMedicationNote:[''],
      Medication:[''],
      MedicationNote:[''],
      BloodThinners:[''],
      BloodThinnersNote:[''],
      Fast:[''],
      FastNote:[''],
      Saturation:[''],
      AdmissionTime: [''],
      EmotionalStatus : [''],
      AssignedDoctor: [''],
      GeneralComment: [''],
      nurseSign:[''],
      PreliminaryTraining:[''],
      AdmissionPainLevel:[''],
    })
  }
  resetTimeOutForm(){
    this.Form = this.fb.group({
      AutoIndex: [''],
      UID:[''],
      PID:[''],
      GID:[''],
      AWLID:[''],
      CreationTime:[''],
      ID: [''],
      InstanceNumber: [''],
      Locked: [''],
      LockedBy: [''],
      Identety:[''],
      IdentetyMatch:[''],
      IdentetyMatchBreclate:[''],
      IdentetyMatchDocumante:[''],
      Guardian:[''],
      GuardianName:[''],
      GuardianID:[''],
      Prosthesis:[''],
      ProcedureType:[''],
      isProc:[''],
      DAC:[''],
      DACName:[''],
      DACSstopped:[''],
      Med:[''],
      MedicationType:[[]],
      validconcentFormSedation:[''],
      validconcentFormAction:[''],
      ProcedureConcentForm:[''],
      MedicConcentForm:[''],
      idType:[''],
      IsIdType:[''],
      medSens:[[]],
      eggSens:[''],
      soyaSens:[''],
      Equipment:[''],
      EquipmentNote:[''],
      DACComments:[''],
      ResponsibleForm:[[]],
      PatientIdentification:[''],
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      AdmissionTime: [''],
      AssignedDoctor: [''],
      nurseSign:[''],
      doctorSign:[''],
    })
  }
  resetRecoveryForm(){
    this.Form = this.fb.group({
      AutoIndex: [''],
      UID:[''],
      PID:[''],
      GID:[''],
      AWLID:[''],
      CreationTime:[''],
      ID: [''],
      InstanceNumber: [''],
      Locked: [''],
      LockedBy: [''],
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      PatientIdentification:[''],
      mobility:[''],
      mobilityNote:[''],
      breathingNote:[''],
      breathing:[''],
      HemodynamicsNote:[''],
      Hemodynamics:[''],
      recognitionNote:[''],
      recognition:[''],
      skinToneNote:[''],
      skinTone:[''],
      nurseSign:[''],
    })
  }

  resetReleaseForm(){
    this.Form = this.fb.group({
      AutoIndex: [''],
      UID:[''],
      PID:[''],
      GID:[''],
      AWLID:[''],
      CreationTime:[''],
      ID: [''],
      InstanceNumber: [''],
      Locked: [''],
      LockedBy: [''],
      consciousState:[''],
      providingDrink:[''],
      InstructionRelease:[''],
      Dentures:[''],
      personalEquipment:[''],
      TakeOutVanaflon:[''],
      ReleaseTime:[''],
      ResponsibleForm:[''],
      nurseSign:[''],
      PatientIdentification:[''],
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      AdmissionTime: [''],
      AssignedDoctor: [''],
      EndTime:[],
      accompanied:[]
    
    })
  }

  CourseOfExamForm(){
    this.Form = this.fb.group({
      AutoIndex: [''],
      UID:[''],
      PID:[''],
      GID:[''],
      AWLID:[''],
      CreationTime:[''],
      ID: [''],
      InstanceNumber: [''],
      Locked: [''],
      LockedBy: [''],
      consciousState:[''],
      providingDrink:[''],
      InstructionRelease:[''],
      Dentures:[''],
      personalEquipment:[''],
      TakeOutVanaflon:[''],
      ReleaseTime:[''],
      ResponsibleForm:[''],
      nurseSign:[''],
      PatientIdentification:[''],
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      AdmissionTime: [''],
      AssignedDoctor: [''],
      PainLevel:[''],
      Byopsy:[''],
      Plate:[''],
      PlateText:[''],
      SkinBefore:[''],
      SkinAfter:[''],
      DuringProc:[''],
      DuringProcText:[''],
      EndTime:[''],
      MedicationText:[''],
      MedicationType:[[]],
      DeviceNumber:[''],
      Sedation:[''],
      HpTaken:[''],
      HpResult :[''],
      Spot:[''],
      Polypectomy:[''],
      DeviceType:[[]],
      OpenVein:[''],
      receivesOxygen:[''],
    })
  }

  resetConsentForm(){
    this.Form = this.fb.group({
      AutoIndex: [''],
      UID:[''],
      PID:[''],
      GID:[''],
      AWLID:[''],
      CreationTime:[''],
      ID: [''],
      Locked: [''],
      LockedBy: [''],
      action:[''],
      doctor:[''],
      patSign:[''],
      guardianSign:[''],
      PatientIdentification:[''],
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      SedationConsent:[''],
      EndoscopyConsent:[''],
      AdmissionTime: [''],
      otherTreatment:[''],
      Guardian:[''],
      GuardianName:[''],
      docSign:[''],
      docLicense:['']
    })
  }
 

  setPat(pat:Patient){
    this.pat = pat;
  }
  loadForm(isTimeOut,form, awl =null, save = false,formName=""){
    if(!this.awlIndex){
      this.awlIndex = awl;
    }
    if(isTimeOut=='fromExam' ){
      this.awlIndex=this.es.AWLID
    }
    if(!form)
      return;
    if(isTimeOut || (form && form['FormName'] == 'Time Out Form') || formName==='Time Out Form'){
      this.typeForm = 'Time Out Form';
      
      this.resetTimeOutForm();
    }
    else if(formName=='Recovery Form' ||(form && form['FormName'] == 'Recovery Form') ){
      this.resetRecoveryForm()
      this.typeForm = formName;
    }
    else if(formName=='Release Form' ||(form && form['FormName'] == 'Release Form') ){
      this.resetReleaseForm()
      this.typeForm = formName;
    }
    else if(formName=='Course Of Exam' ||(form && form['FormName'] == 'Course Of Exam') ){
      this.CourseOfExamForm()
      this.typeForm = formName;
    }
    
   
    else if(formName=='Admission Form'|| form && form['FormName'] == 'Admission Form'){
      this.typeForm = formName;
      this.resetAdmissionForm();
    }

    else if(formName=='Form of Consent'|| form && form['FormName'] == 'Form of Consent'){
      this.typeForm = formName;
       this.resetConsentForm();
    }
    else{
      this.typeForm=null
      this.Form=null
    }
    if(this.awlIndex && this.Form)
      this.fillForm(this.Form, 'GastroForms', [], this.awlIndex, save,)
  }
//----------------------------------------------------Start Print Form----------------------------------------------------------------------//
// works on print 
  getForm(){
    this.loaded=false;

    this.http.get(`/api/gastro/getFormByIndex/${this.FormIndex}`).subscribe((data)=>{
      this.form=data['data'][0];
      this.recoveryMeas=data['measurements']
      const creationTime = data['data'][0]['CreationTime'];
      const utcDate = new Date(creationTime);
      utcDate.setHours(utcDate.getHours() + 2);
      const formattedCreationTime = utcDate.toISOString().replace('T', ' ').replace('Z', '');
      this.form['CreationTime'] = formattedCreationTime;

      this.form['data']=[]
      for(var i of this.listType){
        this.form['data'][i] =[]
      }
      for(var key of this.list){
        if(this.form[key.name] >-1){
          this.form['data'][key.type].push({key, value: this.form[key.name], comment:this.form[key.name+'Note']})
        }
      }
      if(this.form['FormName']=='Recovery Form'){
       this.totalRecoveryScore=this.form['mobility']+this.form['breathing']+this.form['Hemodynamics']+this.form['recognition']+this.form['skinTone']
      }
      this.getAllSigns().subscribe((data:Array<{}>)=>{
      this.signs=data
      })
      this.getSigners();
      this.loaded = true;
    });
  }
// COURSE OF EXAMS SIGNS
  getAllSigns(formID=this.FormIndex){
    return this.http.get('/api/gastro/getAllSigns/'+formID);
  }
// COURSE OF EXAMS SIGNS
  saveSign(form){
    return this.http.post('/api/gastro/saveSign', {form: form,formID:this.FormIndex})
 }

  loadExam(id:number,PID: number,doImages: boolean, code:string = null, gastro = false){
    this.loaded=false;
    this.loadct=0;
    this.FormIndex=id;
    this.PID=PID;
    this.code = code;
    this.getPatient();
    this.fetchImages = doImages;
  }

  getPatient(){
    if(this.code){
      // Restore the print session from the one-time token first, then fetch as a normal authenticated request.
      this.http.post("api/restoreSession",{'code':this.code.toString()}).subscribe(()=>{
        this.fetchPatient();
      },(error)=>{
        console.log(error);
      });
    } else {
      this.fetchPatient();
    }
  }

  fetchPatient(){
    this.http.post("api/patient",{'PatID':this.PID}).subscribe((data)=>{
      if(! data.hasOwnProperty('empty'))
        this.pat = new Patient('3','','','');
        this.pat.asignVals(data);
        this.patServ.setPat(this.pat);
        this.http.get('/api/getenv').subscribe((data)=>{
          this.env = data;
          if(data["printSkipPercentiles"])
            this.showPercentiles = false;
            if (data['htmlheader']) {
              this.htmlHeaderLoad$.next(data['htmlheader'])
            }
          this.getForm();
        },(error)=>{
          console.log(error);
        });

    },
    (error)=>{
      console.log(error);
    });
  }
//----------------------------------------------------End Print Form----------------------------------------------------------------------//



  fillForm(form:UntypedFormGroup, table: string, nosave = [], AWLID=this.awlIndex, save = false){
    this.table = table;
    let params = {'table':table, PatID: this.patServ.getPat().PID.toString(), AWLID: AWLID, ID:this.patServ.getPat().ID.toString(), FormName:this.typeForm, create: save};
    let f = this.http.get("/api/gastro/get",{'params':params});
    f.subscribe((data: any)=>{
      if(!data.hasOwnProperty("empty")){
        this.FormIndex = data[0]['AutoIndex']

        // need to be array -- select multiple
        const medSensArray =data[0]?.medSens ? data[0]?.medSens.split(','):[]
        data[0].medSens=medSensArray
        const responsibleFormArray =data[0]?.ResponsibleForm ? data[0]?.ResponsibleForm.split(','):[]
        data[0].ResponsibleForm=responsibleFormArray
        const MedicationTypeArray =data[0]?.MedicationType ? data[0]?.MedicationType.split(','):[]
        data[0].MedicationType=MedicationTypeArray
        const DeviceTypeArray =data[0]?.DeviceType ? data[0]?.DeviceType.split(','):[]
        data[0].DeviceType=DeviceTypeArray

        form.patchValue(data[0], {emitEvent: false});


       

      }
      else{
        if (data?.data?.AutoIndex)   this.FormIndex = data.data.AutoIndex;
        form.reset({emitEvent:false});
      }
      
      
      for (let key in form.controls) {
        if( ! this.ls.category.canChange.form){
          form.get(key).disable({emitEvent:false});
        }
        else
          if(! nosave.includes(key)&& (data[0]|| data?.data) )
            form.controls[key].valueChanges.pipe(debounceTime(this.debounce), distinctUntilChanged()).subscribe(data=>{
              if(data != null)
                this.saveVals(key,form.get(key).value, table);
            }); 
      }

      // We pass the form object we get: new form / existing form:
      this.formLoaded$.next(data?.data ? data.data : data[0]);
    }, (error)=>{
      console.log(error);
    });
    return f;
  }

  saveConsentForm(){
    return this.http.post('/api/gastro/saveConsentForm',{form:this.Form.value,PatID: this.patServ.getPat().PID.toString(), AWLID:  this.patServ.getPat().AWLID, ID:this.patServ.getPat().ID.toString(), FormName:this.typeForm})
  }

  saveVals(key: string, value: any,table=this.table){
    let p = this.patServ.getPat();
    let values = {
      'table': table,
      'PID': p.PID,
      'AutoIndex': this.FormIndex,
      'ID': p.ID,
      'AWLID': p.AWLID,
      'CreationTime': new Date(),
      'field': key,
      'value': value,
    };
    this.http.post('/api/gastro/save',values).subscribe((data)=>{
      console.log(data);
      //later on add observer for saves/errors
    }, (error)=> {// do this part later
      console.log(error);
    });
  }
  ngOnDestroy(): void {
      this.sub.unsubscribe()
  }

  getVisits(PID:number){
    return this.http.get(`/api/gastro/GetVisits/${PID}`)
  }

  getFormByVisit(AWLID){
    // console.log(AWLID);
    return this.http.get(`/api/gastro/GetFormByAWL/${AWLID}`)
  }

  getDisplay(name){
    var index = this.list.filter((i) => {return i.name === name})
    return index[0].displayName;
  }

  getSigners(){
    this.http.get('/api/gastro/signers/' + this.FormIndex).subscribe((data)=> {
      this.signers = data;
    },(error)=> {
      console.log(error);
    });
  }
}
